/*
  Note: previously there was no tsconfig file for the existing ts components on the backend
  after I added one this and a few other files that were previously going unchecked started throwing errors.
  I didn't want to refactor these files in the current sprint so just opted for the @ts-nocheck below.
  This component also appears to be unused so could probably be removed - TD 31/1/22
 */
// TODO: refactor this file to be abide by tsconfig rules or remove if redundant
// @ts-nocheck
import * as React from 'react';

import Box from '@rexlabs/box';
import {
  Checkbox as VividCheckbox,
  CheckboxProps as VividCheckboxProps
} from '@rexlabs/checkbox';
import {
  StyleSheet,
  styled,
  StylesProps,
  StylesProvider
} from '@rexlabs/styling';

export type CheckboxProps = VividCheckboxProps;

const defaultStyles = StyleSheet({
  checkboxContainer: {
    minHeight: '4rem'
  }
});

const CHECKBOX_TOKENS = {
  checkbox: {
    container: {
      height: 'auto'
    }
  }
};

function Checkbox({ styles: s, ...props }: CheckboxProps & StylesProps<any>) {
  return (
    <StylesProvider tokens={CHECKBOX_TOKENS}>
      <Box flex={1} {...s('checkboxContainer')}>
        <VividCheckbox {...props} />
      </Box>
    </StylesProvider>
  );
}

export default styled(defaultStyles)(Checkbox);
